import React from "react"

import { SelectProductBaseVariantOverlayView } from "./SelectProductBaseVariantOverlayView"
import { useSelectProductBaseVariantOverlayViewModel } from "./hooks/useSelectProductBaseVariantOverlayViewModel"

export interface SelectProductBaseVariantOverlayPayload {
  onSelect: () => void
}

export interface SelectProductBaseVariantOverlayProps {
  payload: SelectProductBaseVariantOverlayPayload
}

export const SelectProductBaseVariantOverlay = React.memo(
  (props: SelectProductBaseVariantOverlayProps) => (
    <SelectProductBaseVariantOverlayView
      {...useSelectProductBaseVariantOverlayViewModel(props)}
    />
  )
)

declare module "shared/context/overlay/registry" {
  interface OverlayPayloadRegistry {
    SELECT_PRODUCT_CONFIGURATION_PRESET_OVERLAY: SelectProductBaseVariantOverlayPayload
  }
}
